<script>
import Vue from 'vue'
import axios from 'axios'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'

import { required } from 'vuelidate/lib/validators'

/**
 * Agregar Certificado Component
 */
export default {
  components: { Layout, PageHeader },
  page: {
    title: 'Certificado',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  data() {
    return {
      title: 'Certificado',
      form: {
        rfc: '',
        razonSocial: '',
        direccion: '',
        cp: '',
        password: '',
        certificado: null,
        publicKey: null,
      },
      archivoSeleccionadoCer: {
        tamano: 0,
        tipo: '',
      },
      archivoSeleccionadoKey: {
        tamano: 0,
        tipo: '',
      },
      items: [
        {
          text: 'Sistemas Tributario',
          href: '/',
        },
        {
          text: 'Certificado',
          href: '/Certificado/',
        },
        {
          text: 'Nuevo',
          active: true,
        },
      ],
      submitted: false,
      isBusy: false,
    }
  },
  validations: {
    form: {
      rfc: {
        required,
      },
      razonSocial: {
        required,
      },
      direccion: {
        required,
      },
      cp: {
        required,
      },
      password: {
        required,
      },
    },
    archivoSeleccionadoCer: {
      tamano: {
        required,
      },
      tipo: {
        required,
      },
    },
    archivoSeleccionadoKey: {
      tamano: {
        required,
      },      
    },
  },
  computed: {},
  mounted() {},
  methods: {
    _validations() {
      return new Promise((resolve) => {
        if (this.$v.$error || !this.$v.$pending) {
          return resolve()
        }
        let poll = setInterval(() => {
          if (!this.$v.$pending) {
            clearInterval(poll)
            resolve()
          }
        }, 200)
      })
    },

    async isValid() {
      this.$v.$reset()
      this.$v.$touch()
      await this._validations()
      return Promise.resolve(!this.$v.$error)
    },

    async handleSubmit(e) {
      this.submitted = true
      const valid = await this.isValid()
      this.isBusy = false

      if (valid) {
        this.isBusy = true

        let formData = new FormData()
        formData.append('rfc', this.form.rfc)
        formData.append('razonSocial', this.form.razonSocial)
        formData.append('direccion', this.form.direccion)
        formData.append('cp', this.form.cp)
        formData.append('password', this.form.password)
        formData.append('certificado', this.$refs.fileDocumento.files[0])
        formData.append('publicKey', this.$refs.fileDocumentoKey.files[0])

        axios
          .post(appConfig.recursosApi.certificado, formData, {
            Accept: 'application/json',
            'Content-Type': 'multipart/form-data',
          })
          .then((response) => {
            this.isBusy = false
            this.$router.push('/certificado/index/true')
          })
          .catch(() => {
            this.isBusy = false
            Vue.swal({
              type: 'error',
              title: 'Oops...',
              text: 'Ocurrio un error al intentar guardar los datos.',
              confirmButtonClass: 'btn btn-confirm mt-2',
            })
          })
      }
    },
    handleFileUpload(e) {
      this.form.certificado = this.$refs.fileDocumento.files[0]
      if (this.$refs.fileDocumento.files.length > 0) {
        this.archivoSeleccionadoCer.tamano =
          this.$refs.fileDocumento.files[0].size / 1024 / 1024
        this.archivoSeleccionadoCer.tipo =
          this.$refs.fileDocumento.files[0].type
      }
    },
    handleFileUploadKey(e) {
      this.form.publicKey = this.$refs.fileDocumentoKey.files[0]
      if (this.$refs.fileDocumentoKey.files.length > 0) {
        this.archivoSeleccionadoKey.tamano =
          this.$refs.fileDocumentoKey.files[0].size / 1024 / 1024

          
        this.archivoSeleccionadoKey.tipo =
          this.$refs.fileDocumentoKey.files[0].type          
      }
    },
  },
}
</script>
<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="row">
      <div class="col-lg-6">
        <div class="card-box">
          <h4 class="header-title m-t-0">Nuevo Certificado</h4>
          <p class="text-muted font-14 m-b-20"
            >Ingresa la información del Certificado.</p
          >

          <form @submit.prevent="handleSubmit">
            <!-- Datos Usuario -->
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">
                  RFC
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="rfc"
                  v-model="form.rfc"
                  name="rfc"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.rfc.$error,
                  }"
                  type="text"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.rfc.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.rfc.required"
                    >El campo es obligatorio.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-6"> </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label>
                  Razon Social
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.razonSocial"
                  type="text"
                  name="razonSocial"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.razonSocial.$error,
                  }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.razonSocial.$error"
                  class="invalid-feedback"
                >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-8">
                <label>
                  Direccion
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.direccion"
                  type="text"
                  name="direccion"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.direccion.$error,
                  }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.direccion.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.direccion.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-4">
                <label>
                  C.P.
                  <span class="text-danger">*</span>
                </label>
                <input
                  v-model="form.cp"
                  type="text"
                  name="cp"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.cp.$error,
                  }"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.cp.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.cp.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="example-fileinput">Selecciona el .cert</label>
                <input
                  id="documento"
                  ref="fileDocumento"
                  class="form-control"
                  type="file"
                  accept=".cer"
                  :class="{
                    'is-invalid': submitted && $v.archivoSeleccionadoCer.$error,
                  }"
                  @change="handleFileUpload"
                />
                <div
                  v-if="submitted && !$v.archivoSeleccionadoCer.tipo.required"
                  style="display: block"
                  class="invalid-feedback"
                  >Debe seleccionar un archivo.</div
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-12">
                <label for="example-fileinput">Selecciona el .key</label>
                <input
                  id="documento"
                  ref="fileDocumentoKey"
                  class="form-control"
                  type="file"
                  accept=".key"
                  :class="{
                    'is-invalid': submitted && $v.archivoSeleccionadoKey.$error,
                  }"
                  @change="handleFileUploadKey"
                />
                <div
                  v-if="submitted && !$v.archivoSeleccionadoKey.tamano.required"
                  style="display: block"
                  class="invalid-feedback"
                  >Debe seleccionar un archivo.</div
                >
              </div>
            </div>
            <div class="form-row">
              <div class="form-group col-md-6">
                <label for="name">
                  Contraseña
                  <span class="text-danger">*</span>
                </label>
                <input
                  id="cuentaId"
                  v-model="form.password"
                  name="categoriaId"
                  class="form-control"
                  :class="{
                    'is-invalid': submitted && $v.form.password.$error,
                  }"
                  type="password"
                  placeholder=""
                />
                <div
                  v-if="submitted && $v.form.password.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.form.password.required"
                    >El campo es requerido.</span
                  >
                </div>
              </div>
              <div class="form-group col-md-6"> </div>
            </div>

            <div class="form-group text-right m-b-0">
              <button class="btn btn-primary" type="submit" :disabled="isBusy">
                <b-spinner v-show="isBusy" small></b-spinner> Guardar</button
              >
              <router-link
                class="btn btn-secondary m-l-5 ml-1"
                to="/certificado/index"
              >
                Cancelar</router-link
              >
            </div>
          </form>
        </div>
        <!-- end card-box -->
      </div>
    </div>
  </Layout>
</template>